<div *ngIf="zcStatistic; else no_zoning_code">
    <ng-container *ngIf="data">
        <h2>Zoning code statistic</h2>
    </ng-container>

    <div class="mat-typography">
        <div class="mat-typography content">
            <p>Zoning code records (GAPI): {{ zcStatistic?.zoningCodeRecords | number }} </p>
            <p>Cached property records (ZAPI): {{ zcStatistic.totalPropertyRecords | number }}</p>
            <p>Property records left: {{ zcStatistic.currentExpectedRecords | number }}</p>
            <p>Progress: {{ zcStatistic.progress }}%</p>
        </div>
    </div>

    <div *ngIf="zoningCodeRecord">
        <h4 class="md-subhead">Synchronization with Solr</h4>
        <app-zoning-code-versions-au-statistic
            [zoningCodeRecord]="zoningCodeRecord"></app-zoning-code-versions-au-statistic>
    </div>
</div>

<ng-template #no_zoning_code>
    <h2>Zoning code not found</h2>
</ng-template>